import arrow_back_ios_new from "../assets/Images/arrow_back_ios_new.png";
import retry from "../assets/Images/retry.svg";
import "../assets/css/style.css";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { AsaStateContext } from '../components/AsaStateProvider'
import { useNavigate  } from "react-router-dom";
export default function FailPage() {
  const { t } = useTranslation();
  const [state, ] = useContext(AsaStateContext)
  //const navigate = useNavigate();
  const handleBackClick =()=>{
    if(state?.dynamicLink){
        window.location.href = state.dynamicLink;
    }
  }
  const handleRetryClick = () => {
    //navigate(-1);
    //navigate('.', { replace: true }); 
    window.location.reload( );
  }
  return (
    <div className="flex justify-center items-center  h-screen asa-default-repeat-bkg">
   
      <div className="w-full h-full flex flex-col  text-white relative z-20">
      
         
        <div className="flex items-center justify-between p-4 mt-2 h-[72px] ">
          <span className="asa-default-bkg size-9 rounded-lg shadow-[0_24px_24px_rgba(0,0,0,0.25)] " >
         
            <img
              alt="back"
              onClick={handleBackClick}
              className="cursor-pointer p-2 shadow-2xl rounded-lg w-9 h-9"
              src={arrow_back_ios_new}
 
            />
          </span>
      
        </div>
          
        <div className="flex-grow relative rounded-t-3xl mt-6 p-6 flex flex-col bg-[#EBECF0] dark:bg-[#121212]">

            <div className="flex flex-col  mt-2">
                <img src={retry} className="mx-auto mt-20" alt="retry" />
            </div>
          <div className="flex flex-grow flex-col  mt-4">
            <div className="flex flex-col mx-10">
              <span className="text-[#4E4E4E] dark:text-[#FDFDFD] font-poppins text-center text-lg/5">
               {t("tryagain") }
            </span>
            </div>
          </div>
            <div className="flex flex-end flex-col mt-10 ">
                <button 
                  className="asa-default-bkg text-white font-poppins text-lg/5 font-bold h-12 mx-10 rounded-lg shadow-[0_24px_24px_rgba(0,0,0,0.25)] uppercase"
                    onClick={handleRetryClick}>
                    {t("retry")}

                  </button>

            </div>
        </div>
      </div>
    </div>
  );
}
